module.exports = __webpack_public_path__ + "static/media/cover.deb1d012.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/dashl/cover.jpg
// module id = 61
// module chunks = 0